import script from "./UncoveredColorsMarker.vue?vue&type=script&setup=true&lang=js"
export * from "./UncoveredColorsMarker.vue?vue&type=script&setup=true&lang=js"

import "./UncoveredColorsMarker.vue?vue&type=style&index=0&id=93cb9e02&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93cb9e02"]])

export default __exports__